"use client";

import AdUnit from "./AdUnit";

// Homepage Top Ad
export const HomepageTopAd = ({ className = "" }) => {
  return (
    <div
      className={`bg-[#fbfbfb] text-center p-[10px] h-[320px] overflow-hidden w-full before:content-['विज्ञापन'] before:block before:text-center before:text-[12px] before:text-[#888] before:mb-[6px] ${className}`}
    >
      {/* <AdUnit
        slot="7456919850"
        style={{
          display: "inline-block",
          width: "1000px",
          height: "280px",
        }}
      /> */}
    </div>
  );
};

// News Detail Page Top Ad
export const NewsDetailTopAd = ({ className = "" }) => {
  return (
    <div
      className={`bg-[#fbfbfb] text-center p-[10px] h-[120px] overflow-hidden w-full before:content-['विज्ञापन'] before:block before:text-center before:text-[12px] before:text-[#888] before:mb-[6px] ${className}`}
    >
      {/* <AdUnit
        slot="7155297835"
        style={{
          display: "inline-block",
          width: "728px",
          height: "90px",
        }}
      /> */}
    </div>
  );
};

// Sidebar Ad
export const SidebarAd = ({ className = "" }) => {
  return (
    <div
      className={`bg-[#fbfbfb] text-center p-[10px] h-[370px] overflow-hidden w-full before:content-['विज्ञापन'] before:block before:text-center before:text-[12px] before:text-[#888] before:mb-[6px] ${className}`}
    >
      {/* <AdUnit
        slot="3381233034"
        style={{
          display: "inline-block",
          width: "320px",
          height: "320px",
        }}
      /> */}
    </div>
  );
};

// Mobile Ad Unit
export const MobileAdUnit = ({ className = "" }) => {
  return (
    <div
      className={`bg-[#f9f9f9] text-center p-[10px] h-[360px] overflow-hidden w-full rounded-[2px] before:content-['विज्ञापन'] before:block before:text-center before:text-[12px] before:text-[#888] before:mb-[6px] ${className}`}
    >
      {/* <AdUnit
        slot="3381233034"
        style={{
          display: "inline-block",
          width: "320px",
          height: "320px",
        }}
      /> */}
    </div>
  );
};

// In Article Ad
export const InArticleAd = ({ className = "" }) => {
  return (
    <div
      className={`bg-[#f9f9f9] text-center p-[10px]  h-[360px] overflow-hidden w-full rounded-[2px] before:content-['विज्ञापन'] before:block before:text-center before:text-[12px] before:text-[#888] before:mb-[6px] ${className}`}
    >
      {/* <AdUnit
        slot="8695718010"
        layout="in-article"
        format="fluid"
        style={{
          display: "block",
          textAlign: "center",
        }}
      /> */}
    </div>
  );
};
